<ui-card [loading]="isLoading">
    <app-segment-header title="time-off-v3.policyComponents.accrualCard.accrualScheduleHeader"></app-segment-header>

    <h4>{{ 'time-off-v3.policyComponents.accrualCard.accrualFrequency' | translate }}</h4>

    <mat-form-field class="restricted-width">
        <mat-label appRemoveAriaOwns>{{
            'time-off-v3.policyComponents.accrualCard.accrualFrequency' | translate
        }}</mat-label>
        <mat-select
            name="accrualFrequency"
            #accrualFrequency="ngModel"
            placeholder="{{ 'time-off-v3.policyComponents.accrualCard.accrualFrequency' | translate }}"
            [(ngModel)]="timeOffPolicy.accrualFrequency"
            (selectionChange)="calculateDaysForPeriod(); accrualPreviews = []"
            required
        >
            <mat-option
                *ngFor="let accrualFrequency of accrualFrequencies | keyvalue: compareAccrualFrequencies"
                [value]="accrualFrequency.key"
                >{{ 'time-off-v3.' + accrualFrequency.key | translate }}</mat-option
            >
        </mat-select>
        <mat-error *ngIf="accrualFrequency.invalid">{{ accrualFrequency.errors | formErrors }}</mat-error>
    </mat-form-field>

    <ng-container [ngSwitch]="timeOffPolicy.accrualFrequency">
        <!-- add comment to explain field container class -->
        <app-weekly-fields
            *ngSwitchCase="'weekly'"
            [timeOffPolicy]="timeOffPolicy"
            (requestPreviewParams)="getAccrualPreview($event)"
            containerClass=""
            fieldClass=""
            firstDayOfPeriodLabel="time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod"
            class="display-block restricted-width"
        ></app-weekly-fields>

        <app-bi-weekly-fields
            *ngSwitchCase="'bi-weekly'"
            [timeOffPolicy]="timeOffPolicy"
            (requestPreviewParams)="getAccrualPreview($event)"
            containerClass=""
            fieldClass=""
            firstDayOfPeriodLabel="time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod"
            class="display-block restricted-width"
        ></app-bi-weekly-fields>

        <app-semi-monthly-fields
            *ngSwitchCase="'semi-monthly'"
            [timeOffPolicy]="timeOffPolicy"
            (requestPreviewParams)="getAccrualPreview($event)"
            containerClass=""
            fieldClass=""
            firstDayOfPeriodLabel="time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod"
            class="display-block restricted-width"
        >
        </app-semi-monthly-fields>

        <app-monthly-fields
            *ngSwitchCase="'monthly'"
            [timeOffPolicy]="timeOffPolicy"
            (requestPreviewParams)="getAccrualPreview($event)"
            containerClass=""
            fieldClass=""
            firstDayOfPeriodLabel="time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod"
            class="display-block restricted-width"
        ></app-monthly-fields>

        <app-quarterly-fields
            *ngSwitchCase="'quarterly'"
            [timeOffPolicy]="timeOffPolicy"
            (requestPreviewParams)="getAccrualPreview($event)"
            containerClass=""
            fieldClass=""
            firstDayOfPeriodLabel="time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod"
            class="display-block restricted-width"
        ></app-quarterly-fields>

        <app-annual-fields
            *ngSwitchCase="'annually'"
            [timeOffPolicy]="timeOffPolicy"
            (requestPreviewParams)="getAccrualPreview($event)"
            containerClass=""
            fieldClass=""
            firstDayOfPeriodLabel="time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod"
            class="display-block restricted-width"
        >
        </app-annual-fields>
    </ng-container>

    <div *ngIf="timeOffPolicy.accrualFrequency && timeOffPolicy.accrualFrequency !== 'daily'">
        <mat-form-field class="restricted-width">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.accrualsHappenOn' | translate }}</mat-label>
            <mat-select
                name="accrualTiming"
                #accrualTiming
                #accrualTimingModel="ngModel"
                placeholder="{{ 'time-off-v3.accrualTiming' | translate }}"
                [(ngModel)]="timeOffPolicy.accrualTiming"
                (selectionChange)="getAccrualPreview(timeOffPolicy.accrualFrequency)"
                required
            >
                <mat-option [value]="'first-day'">{{ 'time-off-v3.firstDayOfPeriod' | translate }}</mat-option>
                <mat-option [value]="'last-day'">{{ 'time-off-v3.lastDayOfPeriod' | translate }}</mat-option>
                <mat-option [value]="'next-first-day'">{{ 'time-off-v3.firstDayOfNextPeriod' | translate }}</mat-option>
            </mat-select>
            <mat-error *ngIf="accrualTimingModel.invalid">{{ accrualTimingModel.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <h4 class="margin-top-0">
        {{ 'time-off-v3.policyComponents.accrualSchedule.doYouWantToProrateFirstAccrual' | translate }}
    </h4>

    <mat-radio-group
        required
        name="prorateFirstAccrual"
        class="vertical"
        name="myRadioGroup"
        ngModel
        #radioGroup="ngModel"
        [(ngModel)]="timeOffPolicy.proratesFirstAccrual"
    >
        <div class="flex col">
            <mat-radio-button [attr.data-cy]="'yes-prorate'" class="margin-bottom-1" [value]="true">
                <div>{{ 'time-off-v3.policyComponents.accrualSchedule.yesProrate' | translate }}</div>
                <div class="subscript">
                    {{ 'time-off-v3.policyComponents.accrualSchedule.prorateTheFirstAccrualAmountBased' | translate }}
                </div>
            </mat-radio-button>
            <mat-radio-button [attr.data-cy]="'no-prorate'" [value]="false">
                <div>{{ 'time-off-v3.policyComponents.accrualSchedule.noDontProrate' | translate }}</div>
                <div class="subscript">
                    {{
                        'time-off-v3.policyComponents.accrualSchedule.accrueTheFullAccrualAmountInTheFirst' | translate
                    }}
                </div>
            </mat-radio-button>
        </div>
        <mat-error *ngIf="radioGroup.invalid"> {{ radioGroup.errors | formErrors }} </mat-error>
    </mat-radio-group>

    <a class="margin-top-2 display-block" href="{{ '4409792698135' | i18nHelpCentre }}" target="_blank"
        ><strong>{{
            'time-off-v3.policyComponents.accrualSchedule.checkTheGuideOnHowAccrualsAreProrated' | translate
        }}</strong></a
    >

    <div *ngIf="accrualPreviews.length > 0" class="margin-top-3 margin-bottom-3">
        <h4>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualSchedulePreviewHeader' | translate }}</h4>
        <table class="columns-10 preview-table">
            <thead>
                <tr>
                    <th>{{ 'time-off-v3.policyComponents.accrualSchedule.firstDayOfPeriod' | translate }}</th>
                    <th>{{ 'time-off-v3.policyComponents.accrualSchedule.lastDayOfPeriod' | translate }}</th>
                    <th>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualHappenOnColumn' | translate }}</th>
                    <th>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualAmountColumn' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let accrualPreview of accrualPreviews">
                    <td>{{ accrualPreview.attributes.startDate | i18nDate: 'shortWeekday' }}</td>
                    <td>{{ accrualPreview.attributes.endDate | i18nDate: 'shortWeekday' }}</td>
                    <td>
                        {{
                            getAccrualHappenOnDate(
                                accrualPreview.attributes.startDate,
                                accrualPreview.attributes.endDate
                            ) | i18nDate: 'shortWeekday'
                        }}
                    </td>
                    <td>{{ daysPerPeriod | i18nNum }} {{ unitOfTime | translate | lowercase }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</ui-card>
